export const VINI = {
  fab: "vini-fab",
  panel: "vini-panel",
  close: "vini-close",
  reset: "vini-reset",
  messagesList: "vini-messages",
  message: (i) => `vini-message-${i}`,
  input: "vini-chat-input",
  send: "vini-send-button",
  quickReply: (slug) => `vini-quick-reply-${slug}`,
  openLeadForm: "vini-open-lead-form",
  leadForm: "vini-lead-form",
  leadName: "vini-lead-name",
  leadEmail: "vini-lead-email",
  leadPhone: "vini-lead-phone",
  leadCompany: "vini-lead-company",
  leadRole: "vini-lead-role",
  leadIntent: "vini-lead-intent",
  leadSubmit: "vini-lead-submit",
  leadSuccess: "vini-lead-success",
  leadError: "vini-lead-error",
};
